import Cookies from 'js-cookie';
import { localStg } from '@/utils/storage';

/** 获取登录凭证 */
export function getToken() {
  return localStg.get('token') || '';
}

/** 清除登录凭证 */
export function clearAuthStorage() {
  Cookies.remove(import.meta.env.VITE_LOGIN_COOKIE);
  localStg.remove('token');
}

/** 设置登录凭证 */
export function setToken(token: string) {
  localStg.set('token', token);
}
